module.exports = __webpack_public_path__ + "img/burger-soda.4b4759d6.svg";